import _ from "lodash";

export const numberDivisions = (str) => {
  let st = '';
  str ? st += str : st = '0';
  let x = st.split('.');
  let x1 = x[0];
  let x2 = x.length > 1 ? '.' + x[1] : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    // eslint-disable-next-line
    x1 = x1.replace(rgx, '$1' + '’' + '$2');
  }
  return x1 + x2;
};

export const uuid = () => {
  const chars = '0123456789abcdef'.split('');

  let uuid = [], rnd = Math.random, r;
  uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
  uuid[14] = '4';

  for (let i = 0; i < 36; i++)
  {
    if (!uuid[i])
    {
      r = 0 | rnd()*16;

      uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r & 0xf];
    }
  }

  return uuid.join('');
};

export const round = (value, precision = 2) => {
  if(precision === 0)
    return Math.round(value);

  let exp = 1;
  for(let i = 0; i<precision; i++)
    exp *= 10;

  return (Math.round(value*exp)/exp).toFixed(precision);
};

export const formatCell = (column, value, roundFunc = round, formatNumberFunc = numberDivisions) => {
  const {
    suffix,
    decSeparator,
    decDigits,
  } = column;

  let output = value;
  if (decDigits) {
    output = roundFunc(value, decDigits);
  }

  if (decSeparator) {
    output = formatNumberFunc(output);
  }

  if (suffix) {
    output = output + suffix;
  }

  return output;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getURLParams = location => {
  const searchParams = new URLSearchParams(location.search)
  const params = {}

  for (let key of searchParams.keys()) {
    params[key] = searchParams.get(key)
  }

  return params
};

export const sorter = (a, b, key) => {
  if (a[key] > b[key]) return 1;
  if (a[key] < b[key]) return -1;

  return 0;
};

export const createColumns = (arr, sorter, render, searchObject = false, className = 'ant-table-cell-left') => {
  if (arr === undefined || arr.length === 0) return;

  let columns = [];
  for (let key in arr) {
    const column = arr[key];
    const columnSearch = (typeof searchObject === 'function') ? searchObject(key) : null;
    columns.push({
      title: column.name,
      dataIndex: key,
      rowId: key,
      align: column.align,
      sorter: (a, b) => sorter(a, b, key),
      render: (text, record) => render(text, record, column),
      className: column.isHidden ? 'ant-table-cell-hidden' : column.cellClassName ? 'ant-table-cell-narrow' : className ? className : '',
      isHidden: !!column.isHidden,
      ...columnSearch,
    });
  }

  return columns;
};

export const normalizeString = (str, seperator = '_') => str.split(seperator).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

export const getFieldValue = (arr,  keysArr) => arr.length > 0 && _.find(arr, keysArr).value;
